import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../context/authContext';

const PrivateRoute = ({ children }) => {
  // FIX: Leemos isInitializing para no redirigir mientras el check de auth está en curso
  const { isAuthenticated, isInitializing } = useAuth();

  // Mientras el contexto verifica la sesión contra el servidor, mostramos un loader
  // Esto evita redirigir a '/' a usuarios que SÍ tienen sesión activa
  if (isInitializing) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: '100vh',
          width: '100%',
          backgroundColor: '#f8fafc',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999
        }}
      >
        <div className="text-center">
          {/* Spinner de Bootstrap mientras se verifica la sesión */}
          <Spinner
            animation="border"
            variant="primary"
            role="status"
            style={{ width: '3rem', height: '3rem', borderWidth: '0.25em' }}
          >
            <span className="visually-hidden">Verificando sesión...</span>
          </Spinner>
          <div className="mt-3 text-primary fw-medium opacity-75">Verificando sesión...</div>
        </div>
      </div>
    );
  }

  // Una vez que terminó la inicialización, si no está autenticado, redirige al inicio
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Está autenticado y la inicialización terminó: permite acceder a la ruta
  return children;
};

export default PrivateRoute;
